/**
 * Will be false when running through the dev server (npm start).
 * Production builds refer to the result of an `npm run build` that is deployed to an environment (dev/stg/prd)
 */
export const isProductionBuild = () => {
  return process.env.NODE_ENV.toLowerCase() === 'production'
}
